<template>
  <div>
    <nav class="container-fluid">
      <div class="nav nav-tabs row" id="nav-tab" role="tablist">
        <a
          v-for="item in tabs"
          :key="item.step"
          @click="handleStep(item)"
          :class="[
            'nav-link link-menu col-md-3',
            step == item.step && 'active',
          ]"
          data-toggle="tab"
          role="tab"
        >
          {{ item.title }}
        </a>
      </div>
    </nav>
    <div class="tab-content container-fluid">
      <div
        v-if="step == 'type-of-hosting'"
        class="tab-pane fade show active"
        id="type-of-hosting"
        role="tabpanel"
      >
        <type-of-hosting />
      </div>
      <div
        v-if="step == 'services'"
        class="tab-pane fade show active"
        id="services"
        role="tabpanel"
      >
        <services />
      </div>
    </div>
  </div>
</template>

<script>
import TypeOfHosting from "./readjustment/type-of-hosting.vue";
import Services from "./readjustment/services.vue";

import permission from "../../../lib/permission";

export default {
  name: "Readjustment",

  components: {
    TypeOfHosting,
    Services,
  },

  data() {
    return {
      errors: [],
      loading: false,
      step: "type-of-hosting",

      tabs: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,

    handleStep({ step }) {
      let { menu, tipo, item } = this.$router.currentRoute.query;

      if (step != item) {
        this.$router.replace({ query: { menu, tipo, item: step } });
      }

      this.step = step;
    },

    retrieve() {
      if (permission("read", "readjustment_type_of_hosting")) {
        this.tabs.push({
          title: "HOSPEDAGEM",
          step: "type-of-hosting",
        });
      }

      if (permission("read", "readjustment_service")) {
        this.tabs.push({ title: "SERVIÇOS", step: "services" });
      }

      let { menu, tipo, item } = this.$router.currentRoute.query;

      if (!["type-of-hosting", "services"].includes(item)) {
        this.$router.replace({
          query: { menu, tipo, item: "type-of-hosting" },
        });
        this.step = "type-of-hosting";
      } else {
        this.step = item;
      }
    },
  },
};
</script>
